<template>
  <div class="wrapper inline-grid grid-cols-9 col-gap width-full">
    <header class="page-title col-span-6 col-start-2">
      <h1 class="header-one">
        Cursor
      </h1>
      <p class="page-title__sub">
        Utility classes for cursor styles.
      </p>
    </header>
    <section class="section col-span-6 col-start-2">
      <p>
        The utility helpers for cursors contain a limited list
        for cursor types.
      </p>
      <div class="table">
        <table>
          <thead>
            <tr>
              <th>Class name</th>
              <th>Properties</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code class="code__class">.cursor-auto</code>
              </td>
              <td>
                <code class="code__prop">cursor: auto;</code>
              </td>
            </tr>
            <tr>
              <td>
                <code class="code__class">.cursor-none</code>
              </td>
              <td>
                <code class="code__prop">cursor: none;</code>
              </td>
            </tr>
            <tr>
              <td>
                <code class="code__class">.cursor-not-allowed</code>
              </td>
              <td>
                <code class="code__prop">cursor: not-allowed;</code>
              </td>
            </tr>
            <tr>
              <td>
                <code class="code__class">.cursor-pointer</code>
              </td>
              <td>
                <code class="code__prop">cursor: pointer;</code>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          Auto
        </h2>
      </header>
      <p>
        To set the cursor style to the default type based on the content
        use <code>.cursor-auto</code>.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="cursor-auto..."&gt;&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview>
        <template #preview>
          <div class="preview__wrapper grid grid-cols-3 justify-items-stretch align-items-start width-full">
            <div class="col-start-2 preview__button button button-solid--selective-yellow cursor-auto
            flex align-items-center justify-content-center"
            >
              <span class="button__content body-medium">Hover over the text</span>
            </div>
          </div>
        </template>
      </preview>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          None
        </h2>
      </header>
      <p>
        Use <code>.cursor-none</code> when you want to hide
        the cursor.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="cursor-none..."&gt;
  ...
&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview>
        <template #preview>
          <div class="preview__wrapper grid grid-cols-3 justify-items-stretch align-items-start width-full">
            <div class="col-start-2 preview__button button button-outline-tiara cursor-none
            flex align-items-center justify-content-center"
            >
              <span class="button__content body-medium">Hover</span>
            </div>
          </div>
        </template>
      </preview>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          Not allowed
        </h2>
      </header>
      <p>
        Use <code>.cursor-not-allowed</code> when you want to indicate
        to a user they can't interact with an element. This is similar to
        the default style on a disabled button.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="cursor-not-allowed..."&gt;&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview>
        <template #preview>
          <div class="preview__wrapper grid grid-cols-3 justify-items-stretch align-items-start width-full">
            <div class="col-start-2 preview__button button button-solid--tiara cursor-not-allowed
            flex align-items-center justify-content-center"
            >
              <span class="button__content body-medium">Hover</span>
            </div>
          </div>
        </template>
      </preview>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          Pointer
        </h2>
      </header>
      <p>
        Use <code>.cursor-pointer</code> to indicate a link or
        clickable elements.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="cursor-pointer..."&gt;&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview>
        <template #preview>
          <div class="preview__wrapper grid grid-cols-3 justify-items-stretch align-items-start width-full">
            <div class="col-start-2 preview__button button button-outline--selective-yellow cursor-pointer
            flex align-items-center justify-content-center"
            >
              <span class="button__content body-medium">Hover</span>
            </div>
          </div>
        </template>
      </preview>
    </section>
  </div>
</template>

<script>
import Preview from '@/components/Preview';
import CodeBlock from '@/components/Code-Block';

export default {
  name: 'Cursor',
  components: {
    Preview,
    CodeBlock,
  },
};
</script>
